export const exerciseApi = '/api/v1/videos/exercise_videos/';
